import InlineTooltip, { TOOLTIP_TEXT } from './InlineTooltip';

function HotspotTooltip({
  x,
  y,
  text,
  tooltipText,
  direction,
}: {
  x: number;
  y: number;
  text: string;
  tooltipText: keyof typeof TOOLTIP_TEXT;
  direction?: 'left' | 'right';
}) {
  return (
    <div style={{ left: `${x}%`, top: `${y}%`, position: 'absolute' }}>
      <InlineTooltip
        text={text}
        tooltipText={tooltipText}
        isHotspot={true}
        direction={direction}
      />
    </div>
  );
}

export default HotspotTooltip;
